import React from "react";

import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  FormControl,
  Icon,
  InputAdornment,
  OutlinedInput,
  styled,
  Theme,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: Theme) => ({
  icon: {
    color: theme.palette.grey[400],
  },
}));

const RootStyle = styled("div")(({ theme }) => ({
  margin: theme.spacing(2, 0),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  transition: theme.transitions.create("box-shadow", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
}));

interface Props {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const SearchPanel: React.FC<Props> = ({ onChange }) => {
  const { classes } = useStyles();
  return (
    <RootStyle>
      <Box fontSize={20} fontWeight="700" color="#112340">
        All Clients
      </Box>
      <FormControl size="small">
        <SearchStyle
          onChange={onChange}
          placeholder="Search client"
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} className={classes.icon}>
                <SearchIcon />
              </Box>
            </InputAdornment>
          }
        />
      </FormControl>
    </RootStyle>
  );
};

export default SearchPanel;
